//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchUpdateState, fetchDelete } from "@/api/PMS/customerService/lostAndFound/lostManagement";
import { fetchList as fetchTypeList } from "@/api/PMS/customerService/lostAndFound/goodsType";
import waves from "@/directive/waves"; // 水波纹指令

import detail from "./detail";
import listAdd from "./add";
import clues from "./clues";
import cluesList from "./cluesList";
import confirmFind from "./confirmFind";
import { getUserId } from "@/utils/auth";
export default {
  name: "ComplexTable",
  components: {
    listAdd: listAdd,
    detail: detail,
    clues: clues,
    confirmFind: confirmFind,
    cluesList: cluesList
  },
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10
      },
      userId: parseInt(getUserId()),
      title: "",
      receiverObjectType: "",
      id: -1,
      dates: [],
      lostDates: [],
      typeOptions: [],
      isDetail: false,
      multipleSelection: [],
      dialogFormVisible: false,
      dialogCluesVisible: false,
      dialogConfirmFindVisible: false,
      dialogCluesListVisible: false,
      dialogDetailVisible: false
    };
  },
  created: function created() {
    console.log(this.userId);
    this.getGoodsType();
    this.getList();
  },
  methods: {
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormVisible = false;
      this.dialogCluesVisible = false;
      this.dialogConfirmFindVisible = false;
      this.dialogCluesListVisible = false;
      this.dialogDetailVisible = false;
    },
    getGoodsType: function getGoodsType() {
      var _this = this;

      fetchTypeList({}).then(function (res) {
        _this.typeOptions = res.data.data;
      });
    },
    getClues: function getClues(val) {
      this.id = val.id;
      this.title = "线索列表";
      this.dialogCluesListVisible = true;
    },
    getList: function getList() {
      var _this2 = this;

      this.listLoading = true;

      if (this.lostDates !== null && this.lostDates.length > 0) {
        this.listQuery.beginDate = this.lostDates[0];
        this.listQuery.endDate = this.lostDates[1];
      } else {
        this.listQuery.beginDate = "";
        this.listQuery.endDate = "";
      }

      fetchList(this.listQuery).then(function (response) {
        _this2.list = response.data.data;
        _this2.total = response.data.total;
        _this2.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 创建
    handleCreate: function handleCreate() {
      this.id = -1;
      this.title = "创建";
      this.isDetail = false;
      this.dialogFormVisible = true;
    },
    getRelease: function getRelease(id) {
      var _this3 = this;

      this.$confirm("你确定是要发布这条寻物启事吗, 是否继续?", "提示").then(function () {
        fetchUpdateState({
          id: id,
          publishStatus: 1
        }).then(function (res) {
          if (res.data.code === 200) {
            _this3.getList();

            _this3.Alert({
              alertType: "update",
              message: "发布成功"
            });
          }
        });
      });
    },
    // 编辑
    handleUpdate: function handleUpdate(id) {
      this.id = id;
      this.title = "编辑";
      this.isDetail = false;
      this.dialogFormVisible = true;
    },
    delete: function _delete(ids) {
      var _this4 = this;

      if (ids.length > 0) {
        this.$confirm("你确定是要删除本条记录吗, 是否继续?", "提示").then(function (res) {
          fetchDelete(ids).then(function (res) {
            if (res.data.code === 200) {
              _this4.getList();

              _this4.Alert({
                alertType: "delete"
              });
            }
          });
        });
      } else {
        this.Alert({
          alertType: "nodata"
        });
      }
    },
    // 提供线索
    handleClues: function handleClues(id) {
      this.id = id;
      this.title = "提供线索";
      this.dialogCluesVisible = true;
    },
    // 确认找到
    handleConfirmFind: function handleConfirmFind(id) {
      this.id = id;
      this.title = "确认找到";
      this.dialogConfirmFindVisible = true;
    },
    handleDelete: function handleDelete(id) {
      var ids = [];
      ids.push(id);
      this.delete(ids);
    },
    // 详情
    getDetail: function getDetail(id) {
      this.id = id;
      this.isDetail = true;
      this.title = "详情";
      this.dialogDetailVisible = true;
    }
  }
};